export interface assetInfo {
  totalAssets: number;
  assetSize: number;
  totalDownloads: number;
}

export interface message {
  text: string;
  class: string;
}

export interface ToastMessage {
  text: string;
  type: "success" | "error";
}

export interface CustomDialog {
  actionMap: Map<string, Function>;
  textArray: string[];
}

export interface SearchObject {
  tags: string | null;
  categories: string[];
}

export enum Permission {
  View = "VIEW",
  Edit = "EDIT",
  Delete = "DELETE",
  Download = "DOWNLOAD",
}

export enum CUSTOM_SEPERATOR {
  FOLDER_ID = "---",
}

export interface StringMap {
  [key: string]: string;
}

export enum PRODUCT_STATUS {
  PUBLISHED = "published",
  SUSPENDED = "suspended",
  CREATED = "created",
}

export enum PRODUCT_CATEGORY {
  ARTS = "arts",
  PRINTS = "prints",
  OTHERS = "others",
}

export enum WEB_COMPONENT {
  CART_DETAIL = "cart-detail",
  OPTIONAL_PAY = "optional-pay",
}

export enum DOWNLOAD_STATUS {
  COMPLETED = "completed",
  FAILED = "failed",
  PENDING = "pending",
}

export enum DOWNLOAD_NOTES {
  STARTED = "download started and status pending",
  COMPLETED = "download completed successfully",
  FAILED = "download failed with error",
}
